import { render } from "./UserDropdown.vue?vue&type=template&id=30d54b02"
import script from "./UserDropdown.vue?vue&type=script&lang=js"
export * from "./UserDropdown.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\saidd\\OneDrive\\Desktop\\AKSA\\Projekti\\udruzenje pravobranilaca\\Admin\\vue-notus\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__